import React from 'react';
import BusinessUnitForm from './BusinessUnitForm';
import BusinessUnitsList from './BusinessUnitsList';
const BusinessUnitPage = _ref => {
  let {
    company,
    setCompany,
    loading,
    setLoading,
    handleToaster
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BusinessUnitForm, {
    company: company,
    setCompany: setCompany,
    loading: loading,
    setLoading: setLoading
  }), /*#__PURE__*/React.createElement(BusinessUnitsList, {
    company: company,
    handleToaster: handleToaster,
    setCompany: setCompany,
    loading: loading,
    setLoading: setLoading
  }));
};
export default BusinessUnitPage;